import { useContext, useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import Cta from "../../../components/cta/Cta";
import Recommendation from "../../../components/recommendation/recommendation";
import useInputAdapter from "../../../components/inputAdapter/inputAdapter";
// import contentProvider from "../../../components/contentProvider/contentProvider";
// import productProvider from "../../../components/productProvider/productProvider";
import recommendationsApi from "../../../api/recommendations";
import recommendationsLogic from "../../../components/recommendationsLogic/recommendationsLogic";
import Loader from "../../../components/loader/loader";
import {
  getConsumerLevel,
  getMergedQuestionsAndAnswers,
  setAppBackground,
} from "../../../utils";

import hash from "object-hash";
import * as Survey from "survey-react";

import { surveyModel } from "../../../mock/survey-questions";

import { SurveyContext } from "../../../store/survey-context";

import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Pagination, A11y } from "swiper";

import "./style.scss";
import "swiper/swiper.scss";
import "swiper/components/navigation/navigation.scss";
import "swiper/components/pagination/pagination.scss";

SwiperCore.use([Navigation, Pagination, A11y]);

Survey.Serializer.addProperty("page", "recommendations:array");
Survey.Serializer.addProperty("page", "isAnswered:boolean");

const REACT_APP_API_RECOMMENDATION = process.env.REACT_APP_API_RECOMMENDATION;

const surveyMTC = new Survey.Model(surveyModel());
const Recommendations = () => {
  const { t, i18n } = useTranslation("common");

  // be sure to include correct language - like zh-hant (lowercase)
  let lang = i18n.resolvedLanguage.toLowerCase();
  let base = REACT_APP_API_RECOMMENDATION + "/" + lang;
  let username = null;
  let password = null;
  /*
  if (base.indexOf("qaweb") !== -1 || base.indexOf("devweb") !== -1) {
    username = "edrington";
    password = "Edr1ngt0n!";
  }
  */
  const CONSTANS = {
    header: t("recommendations.header"),
    noRecHeader: t("recommendations.empty"),
    primaryBtn: {
      title: t("button.finish_share"),
      path: "/finish",
    },
    secondaryBtn: {
      title: t("button.go_back"),
      path: "/rings",
    },
  };
  // get all questions from defined json

  const changeRecommendationContext = (recommendations, answersHash, lang) => {
    setRecommendationsData(recommendations);
    recommendationContext = recommendationContext.filter(function (obj) {
      return obj.lang !== lang;
    });
    let recommendationContextNew = [
      ...recommendationContext,
      {
        lang: lang,
        answersHash: answersHash,
        recommendations: recommendations,
      },
    ];
    ctx.setRecommendations(recommendationContextNew, lang);
  };

  const ctx = useContext(SurveyContext);
  const recSlider = useRef(null);

  let recommendationContext = ctx.recommendations,
    recommendationLang = ctx.recommendationsLang,
    answers = ctx.userProfile?.answers,
    levels = {
      novice: "novice",
      connoisseur: "connoisseur",
      expert: "expert",
    },
    macallanWhiskies = ctx.macallanWhiskies,
    providerData = {
      content: [],
      product: [],
    },
    questionsWithReco = [],
    answeredPages = [],
    answersCurrent = [];

  const recommendationsQuantity = 6,
    pages = surveyMTC.pages;

  if (answers) {
    getMergedQuestionsAndAnswers(pages, answers, surveyMTC);
  }

  surveyMTC.pages.forEach((page) => {
    if (typeof page.recommendations !== "undefined") {
      questionsWithReco.push(page);
    }

    if (page.isAnswered && page.isVisible && page.recommendations) {
      answeredPages.push(page);
    }

    const answer = answers[page.crmId];
    if (page.isAnswered && page.isVisible && typeof answer !== "undefined") {
      answersCurrent.push(answer);
    }
  });

  const level = getConsumerLevel(answeredPages, answers, levels);

  // extracting recommendations from visible question answers
  const inputAdapterData = useInputAdapter(
    answers,
    macallanWhiskies,
    answeredPages,
    level
  );

  let inputProduct = inputAdapterData["productCodes"],
    inputContent = inputAdapterData["contentUrls"],
    inputDebug = inputAdapterData["debugInfo"];

  /* mock implementation - TO DELETE after API implementation */
  // let contentData = contentProvider(inputContent, level, "en");
  // let productData = productProvider(inputProduct, "en");

  // api implementation
  let [apiStatus, setApiStatus] = useState(false);
  let [recommendationData, setRecommendationsData] = useState([]);

  // redirecting all api calls to qaweb subdomain
  inputContent = inputContent.map(function (x) {
    if (base.indexOf("qaweb") !== -1) {
      x = x.replace("www", "qaweb");
    } else if (base.indexOf("devweb") !== -1) {
      x = x.replace("www", "devweb");
    }
    return x.replace(".com", ".com/" + lang);
  });

  let inputProductArray = [];
  inputProduct = inputProduct.map(function (x) {
    if (base.indexOf("qaweb") !== -1) {
      x.url = x.url.replace("www", "qaweb");
    } else if (base.indexOf("devweb") !== -1) {
      x.url = x.url.replace("www", "devweb");
    }
    // supplementing url by lang param
    x.url = x.url.replace(".com", ".com/" + lang);
    inputProductArray.push(x.url);
    return x;
  });

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    setAppBackground("Ring_Viz_BG_v2.png", apiStatus ? 0 : 0.7);
  }, [apiStatus]);

  inputProductArray = [...new Set(inputProductArray)];

  useEffect(() => {
    const answersHash = hash(answersCurrent);
    const oldAnswersHash = ctx.storedData?.answersHash;
    let recommendationsObject = {};
    let langChanged = false;
    recommendationsObject = recommendationContext.find((obj) => {
      return obj.lang === lang;
    });

    if (
      typeof recommendationsObject === "undefined" &&
      recommendationLang !== "" &&
      recommendationLang !== lang &&
      typeof recommendationContext[0]?.recommendations !== "undefined"
    ) {
      langChanged = true;
      inputContent.length = 0;
      inputProductArray.length = 0;

      if (typeof recommendationContext[0].recommendations !== "undefined") {
        recommendationContext[0].recommendations.forEach((recommendation) => {
          if (typeof recommendation.cta_url !== "undefined") {
            let ctaUrl = recommendation.cta_url.replace(
              ".com/" + recommendationContext[0].lang + "/",
              ".com/" + lang + "/"
            );
            if (typeof recommendation.verb === "undefined") {
              inputContent.push(ctaUrl);
            } else {
              inputProductArray.push(ctaUrl);
            }
            recommendationContext.cta_url = ctaUrl;
            recommendationContext.url = ctaUrl;
          }
        });
      }
    }

    if (
      typeof recommendationsObject === "undefined" ||
      (typeof oldAnswersHash !== "undefined" &&
        recommendationsObject.answersHash !== oldAnswersHash)
    ) {
      Promise.all([
        recommendationsApi().getContent(
          base,
          inputContent,
          lang,
          level,
          username,
          password,
          true
        ),
        recommendationsApi().getProduct(
          base,
          inputProductArray,
          lang,
          username,
          password,
          true
        ),
      ])
        .then((values) => {
          let products = values[1];
          let mergeByUrl = [],
            filteredUrls = [];
          if (langChanged) {
            values = [...values[0], ...values[1]];
            if (typeof values !== "undefined") {
              recommendationContext[0].recommendations.forEach(
                (recContextElement) => {
                  let element = values.find(function (recApiElement) {
                    return (
                      recApiElement.cta_url ===
                      recContextElement.cta_url.replace(
                        ".com/" + recommendationContext[0].lang + "/",
                        ".com/" + lang + "/"
                      )
                    );
                  });

                  if (
                    element &&
                    typeof recContextElement.verb !== "undefined"
                  ) {
                    element.category = recContextElement.category;
                    element.parentTitle = recContextElement.parentTitle;
                    element.verb = recContextElement.verb;
                    providerData["product"] = element;
                  } else if (element) {
                    providerData["content"].push(element);
                  }
                }
              );

              let recommendations = recommendationsLogic(
                providerData,
                recommendationsQuantity,
                langChanged
              );

              changeRecommendationContext(recommendations, answersHash, lang);
            }
          } else {
            if (typeof values[1] !== "undefined") {
              mergeByUrl = inputProduct.map((itm) => ({
                ...products.find((item) => item.url === itm.url && item),
                ...itm,
              }));

              filteredUrls = mergeByUrl.filter(function (obj) {
                return typeof obj?.cta_url !== "undefined";
              });

              let product =
                filteredUrls[Math.floor(Math.random() * filteredUrls.length)];

              if (typeof product !== "undefined") {
                let productBase = inputProduct.find(
                  (pr) => pr.url === product.url
                );

                if (typeof productBase !== "undefined") {
                  product.parentTitle = productBase.parentTitle;
                  product.verb = productBase.verb;
                  product.category = productBase.category;
                  providerData["product"] = product;
                }
              }
            }

            if (typeof values[0] !== "undefined") {
              providerData["content"] = values[0];
              // Filter data by level, sort by main category and priority,
              // cap to 3 recommendations peer category
              let recommendations = recommendationsLogic(
                providerData,
                recommendationsQuantity
              );
              changeRecommendationContext(recommendations, answersHash, lang);
            }
          }
          setApiStatus(true);
        })
        .catch((error) => {
          setApiStatus(true);
          console.log("err", error);
        });
    } else {
      setRecommendationsData(recommendationsObject.recommendations);
      setApiStatus(true);
    }
  }, [lang]);

  // Debuging tool - Numer of recommendations
  // const [tempCount, setTempCount] = useState(recommendationsQuantity);
  const recommendationsList = recommendationData;

  const recSlides = recommendationsList.map((el, index) => {
    if (typeof el.verb !== "undefined") {
      el.body = t(el.body, {
        verb: t(el.verb),
        customer_product: el.parentTitle,
        recommended_product: el.name,
      });
    }
    return (
      <SwiperSlide key={index}>
        <Recommendation
          header={el.headline}
          title={el.title}
          description={el.body}
          imageUrl={el.image_url}
          ctaUrl={el.cta_url}
          // priority={el.priority}
        />
      </SwiperSlide>
    );
  });

  const keyDownHandler = (e) => {
    if (
      recSlider.current?.swiper !== null &&
      typeof recSlider.current?.swiper !== "undefined"
    ) {
      const slider = recSlider.current.swiper;

      if (
        recSlider?.current.swiper &&
        e.target.className === "recommendation-item__anchor"
      ) {
        if (
          e.keyCode === 39 ||
          (e.keyCode === 9 && !e.shiftKey && !slider.isEnd)
        ) {
          slider.slideNext();
        }

        if (
          e.keyCode === 37 ||
          (e.keyCode === 9 && e.shiftKey && !slider.isBeginning)
        ) {
          slider.slidePrev();
        }
      }
    }
  };

  const onFocusHandler = (e) => {
    if (
      recSlider.current?.swiper !== null &&
      typeof recSlider.current?.swiper !== "undefined"
    ) {
      const slider = recSlider.current.swiper;

      if (
        e.target.className === "recommendation-item__anchor" &&
        !e.target.parentElement.parentElement.previousElementSibling &&
        !slider.isBeginning
      ) {
        slider.slideTo(0);
      }
    }
  };

  return (
    <>
      {apiStatus === false ? (
        <Loader text={t("app.loading")} />
      ) : (
        <section
          className="recommendations"
          onKeyDown={keyDownHandler}
          onFocus={onFocusHandler}
        >
          <header className="recommendations__header">
            <h1 className="recommendations__title headline--secondary text-uppercase mb-50">
              <span className="recommendations__username">
                {ctx.userProfile.firstName}
                {t("recommendations.someones")}{" "}
              </span>
              {CONSTANS.header}
            </h1>
          </header>

          {recommendationsList.length ? (
            <div className="recommendations__list fade-in">
              {recommendationsList.length > 0 ? (
                <Swiper
                  navigation={true}
                  slidesPerView={1}
                  spaceBetween={25}
                  a11y={{
                    prevSlideMessage: t("button.slider_aria_prev"),
                    nextSlideMessage: t("button.slider_aria_next"),
                    paginationBulletMessage: t("button.pagination", {
                      index: "{{index}}",
                    }),
                  }}
                  breakpoints={{
                    768: {
                      slidesPerView: "auto",
                    },
                  }}
                  pagination={{
                    clickable: true,
                  }}
                  watchOverflow={true}
                  ref={recSlider}
                >
                  {recSlides}
                </Swiper>
              ) : (
                <Recommendation
                  header={recommendationsList[0].header}
                  imageUrl={recommendationsList[0].image_url}
                  title={recommendationsList[0].title}
                  description={recommendationsList[0].body}
                  ctaUrl={recommendationsList[0].cta_url}
                  priority={recommendationsList[0].priority}
                />
              )}
            </div>
          ) : (
            <div className="no-recommendations">
              <h2 className="headline headline--quaternary">
                {CONSTANS.noRecHeader}
              </h2>
            </div>
          )}
          <div className="recommendations__actions intor-action-bar mv-50 flex-center action-bar">
            <Cta
              path={CONSTANS.secondaryBtn.path}
              ctaClass="cta--secondary cta--centered prev"
            >
              {CONSTANS.secondaryBtn.title}
            </Cta>
            <Cta
              path={CONSTANS.primaryBtn.path}
              ctaClass="cta--primary cta--centered"
            >
              {CONSTANS.primaryBtn.title}
            </Cta>
          </div>
          {/* TO DELETE after API implementation */}
          <div className="tp-area-helper">
            {/* <input
              type="number"
              value={tempCount}
              min="0"
              max="6"
              onChange={(e) => setTempCount(e.target.value)}
            /> */}
            {/*  */}
            <div>
              <h3 className="mt-50">Values:</h3>
              question crmId: answer: recommendations url
              {inputDebug.map((d, key) => (
                <div key={key}>
                  {d.question}:{" "}
                  <strong className="sv_q_title">{d.answer}</strong>: {d.url}
                </div>
              ))}
            </div>
            <div>
              <h3 className="mt-50">All recommendations:</h3>
              {questionsWithReco.map((d, key) => (
                <div key={key}>
                  <div>{d.crmId}</div> {JSON.stringify(d.recommendations)}
                </div>
              ))}
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default Recommendations;
